import React from "react";
import { Navigate } from "react-router";

function Home() {
  return <Navigate to="/app/offers" replace />;
}

export default Home;
